import MenuComponent from '@/components/MenuComponent'
import FAQNotConnected from './FAQNotConnected'
import FAQPorteur from './FAQPorteur'
import FAQGestionnaire from './FAQGestionnaire'
import FAQAdministrateur from './FAQAdministrateur'

export default {
  components: {
    MenuComponent,
    FAQNotConnected,
    FAQPorteur,
    FAQGestionnaire,
    FAQAdministrateur
  },
  methods: {
    isPorteur () {
      if (this.$store.state.user.user.groupe && (this.$store.state.user.user.groupe.name === 'Porteur' || this.$store.state.user.user.groupe.name === 'DemoPorteur')) {
        return true
      }
      return false
    },
    isGestionnaire () {
      if (this.$store.state.user.user.groupe && (this.$store.state.user.user.groupe.name === 'Gestionnaire' || this.$store.state.user.user.groupe.name === 'DemoGestionnaire')) {
        return true
      }
      return false
    },
    isAdmin () {
      if (this.$store.state.user.user.groupe && (this.$store.state.user.user.groupe.name === 'AdministrateurBO' || this.$store.state.user.user.groupe.name === 'Administrateur' || this.$store.state.user.user.groupe.name === 'AtosWL')) {
        return true
      }
      return false
    }
  }
}
